module.exports = __webpack_public_path__ + "img/blog.26a1360d.jpg";